// Note: This function relies on the order of the Yup schema keys to scroll to the
// first error on the page.

export const scrollToError = (errors) => {
  if (!errors) return;

  let firstErrorKey = Object.keys(errors)[0];
  if (!firstErrorKey) return;

  if (firstErrorKey === "equipments") {
    const equipmentSection = document.querySelector(".equipmentSection");

    if (equipmentSection) {
      equipmentSection.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
  }

  if (errors[firstErrorKey] && Array.isArray(errors[firstErrorKey])) {
    const arrayErrors = errors[firstErrorKey];
    const firstErrorIndex = arrayErrors.findIndex(
      (item) =>
        item && typeof item === "object" && Object.keys(item).length > 0,
    );
    if (firstErrorIndex !== -1) {
      const firstNestedKey = Object.keys(arrayErrors[firstErrorIndex])[0];
      firstErrorKey = `${firstErrorKey}.${firstErrorIndex}.${firstNestedKey}`;
    }
  }

  let el =
    document.querySelector(`[name="${firstErrorKey}"]`) ||
    document.getElementById(firstErrorKey);

  if (!el) {
    console.warn(`Element ${firstErrorKey} not found`);
    return;
  }

  el.scrollIntoView({ behavior: "smooth", block: "center" });

  if (["INPUT", "SELECT", "TEXTAREA"].includes(el.tagName)) {
    // preventScroll stops directly jumping to the error instead of scrolling to it
    el.focus({ preventScroll: true });
  }
};
